<template>
  <ul class="sidebar-menu">
    <li class="has-sub">
      <!--span class="page heading">Velocity</span-->
      <ul>
        <li class="active pageLink" v-on:click="toggleMenu">
          <router-link to="/">
            <img src="/static/img/home.svg" alt="Home"/>
            <span class="label">Home</span>
          </router-link>
        </li>
        <li class="pageLink" v-on:click="toggleMenu">
          <router-link to="/report">
            <i class="fa fa-bar-chart"></i>
            <span class="label">Report</span>
          </router-link>
        </li>
        <!--  <li class="pageLink" v-on:click="toggleMenu">
      <router-link to="/createjob"><i class="fa fa-tasks"></i>
        <span class="page">Create Model</span>
      </router-link>
    </li>
<li class="pageLink" v-on:click="toggleMenu">
      <router-link to="/Displayjob"><i class="fa fa-list"></i>
        <span class="page">Model History</span>
      </router-link>
    </li> -->
      </ul>
    </li>
    <!--     <li class="has-sub">  <span class="page heading">Forecasting Tool</span>
      <ul>
            <li class="pageLink" v-on:click="toggleMenu">
      <router-link to="/forecast"><i class="fa fa-line-chart"></i>
        <span class="page">Forecast</span>
      </router-link>
    </li>
     </ul>
    </li>-->

  </ul>
</template>
<script>
export default {
  name: 'SidebarName',
  methods: {
    toggleMenu (event) {
      // remove active from li
      var active = document.querySelector('li.pageLink.active')

      if (active) {
        active.classList.remove('active')
      }
      // window.$('li.pageLink.active').removeClass('active')
      // Add it to the item that was clicked
      event.toElement.parentElement.className = 'pageLink active'
    }
  }
}
</script>
<style lang="scss">
/* override default */
.sidebar-menu{overflow: visible}
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}

span.heading {
  color: #000;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
  font-size: 15px;
}

.has-sub li a {
  padding: 8px;
  display: block;
}

.has-sub {
	ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

.sidebar-collapse {
  span.page {
    display: none !important;
  }

  .has-sub {
    li a {
      margin-left: 0px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    li {
      list-style: none;
      	position: relative;
	      a.router-link-exact-active:before{
	        content: '';
	        display: block;
	        border: 7px solid #f1b828;
	        border-color: transparent transparent transparent #f1b828;
	        position: absolute;
	        right: -14px;
	        top: 50%;
	        margin-top: -7px;
	      }
      & > a {
	 padding: 15px;
        display: block;
        text-align: center;
        color: #000;
        line-height: 1;
        font-size: 20px;
        img {
            max-width: 22px;
        }
        .label {
          display: block;
          color: #000;
          font: 600 10px 'Verdana';
          padding: 0;
          text-align: center;
          width: 100%;
        }
      }
    }
    & > a {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?177574c3